export const downloads = [
  {
    "id": "tarot-software",
    "slug": {
      "en": "tarot-software",
      "es": "software-de-tarot",
      "nl": "tarot-software",
      "pap": "software-di-tarot"
    },
    "title": {
      "en": "Tarot Software",
      "es": "Software de Tarot",
      "nl": "Tarot Software",
      "pap": "Tarot Software"
    },
    "category": "software",
    "status": "available",
    "language": "multilingual",
    "availableLanguages": [
      "en",
      "de",
      "es",
      "nl",
      "pap"
    ],
    "shortDescription": {
      "en": "AnknA Tarot is a Windows desktop tarot study and psycho-symbolic exploration workbench for self-observation, archetypal literacy, and practical integration.",
      "es": "AnknA Tarot es una mesa de trabajo de Windows para el estudio del tarot y la exploracion psicosimbolica, orientada a la autoobservacion, la alfabetizacion arquetipica y la integracion practica.",
      "nl": "AnknA Tarot is een Windows-desktopwerkbank voor tarotstudie en psycho-symbolische verkenning, gericht op zelfobservatie, archetypische geletterdheid en praktische integratie.",
      "pap": "AnknA Tarot ta un werkbank di Windows pa estudio di tarot i eksplorashon psiko-simboliko, pa auto-observashon, alfabetisashon arketipiko i integrashon praktiko."
    },
    "description": {
      "en": "This portable Windows build supports elemental assessment, tarot correspondences, numerology, planetary-hour reflection, deck study, and integration guidance. It is a reflective study companion, not a fortune-telling app, predictive divination engine, diagnosis tool, or authority over personal destiny.",
      "es": "Esta version portatil para Windows ofrece evaluacion elemental, correspondencias del tarot, numerologia, reflexion con horas planetarias, estudio de mazos y guia de integracion. Es un companero de estudio reflexivo, no una aplicacion de adivinacion, un motor predictivo, una herramienta de diagnostico ni una autoridad sobre el destino personal.",
      "nl": "Deze draagbare Windows-build ondersteunt elementaire beoordeling, tarotcorrespondenties, numerologie, planetaire-urenreflectie, deckstudie en integratiebegeleiding. Het is een reflectieve studiebegeleider, geen waarzeg-app, voorspellende divinatie-engine, diagnosetool of autoriteit over persoonlijk lot.",
      "pap": "E build portatil pa Windows aki ta sostene evaluashon elemental, korrespondensianan di tarot, numerologia, reflektshon ku oranan planetario, estudio di deck i guia di integrashon. E ta un kompanero reflektivo di estudio, no un app di adivinashon, motor prediktivo, herment di diagnostiko ni outoridat riba destino personal."
    },
    "useContext": {
      "en": "Made publicly available as a student gift for the TGWE Tarot courses. The word prompt is a symbolic course threshold, not a security boundary.",
      "es": "Disponible publicamente como regalo para estudiantes de los cursos de Tarot de TGWE. La palabra de acceso es un umbral simbolico del curso, no una barrera de seguridad.",
      "nl": "Publiek beschikbaar gemaakt als studentengeschenk voor de TGWE Tarot-cursussen. De woordprompt is een symbolische cursusdrempel, geen beveiligingsgrens.",
      "pap": "Disponibel publikamente komo regalo pa studiantenan di e kursonan di Tarot di TGWE. E palabra di entrada ta un umbral simboliko di kurso, no un frontera di seguridat."
    },
    "image": null,
    "imageAlt": null,
    "version": "2.0.2",
    "releaseDate": "2026-07-15",
    "license": {
      "en": "Student gift / public download",
      "es": "Regalo para estudiantes / descarga publica",
      "nl": "Studentengeschenk / publieke download",
      "pap": "Regalo pa studiante / download publiko"
    },
    "builds": [
      {
        "platform": {
          "en": "Windows portable ZIP",
          "es": "ZIP portatil para Windows",
          "nl": "Windows portable ZIP",
          "pap": "ZIP portatil pa Windows"
        },
        "url": "/assets/downloads/AnknA-Tarot-Windows-Portable-2026-07-15.zip",
        "fileName": "AnknA-Tarot-Windows-Portable-2026-07-15.zip",
        "size": "1.7 MB",
        "sha256": "ADB026ED353451898D0E26DC6BDBD1740BD11922449ED3C268DE07B5846F3407"
      }
    ],
    "unlock": {
      "enabled": true,
      "words": [
        "truth",
        "maat",
        "ma'at",
        "ma'a kheru",
        "great work",
        "the great work",
        "transformation",
        "transmutation",
        "natural law",
        "inner alchemy",
        "ankh",
        "heka",
        "light",
        "verdad",
        "gran obra",
        "transformacion",
        "transformación",
        "ley natural",
        "waarheid",
        "grote werk",
        "transformatie",
        "natuurwet",
        "berdat",
        "obra grandi",
        "transformashon",
        "lei natural"
      ]
    },
    "faq": null,
    "relatedMediaSeasons": [
      "cycle-1-season-3",
      "cycle-1-season-4"
    ],
    "relatedCourses": [
      "tarot-great-work-practitioner",
      "tarot-great-work-master-training"
    ]
  },
  {
    "id": "nexus-framework",
    "slug": {
      "en": "nexus-framework",
      "es": "marco-nexus",
      "nl": "nexus-framework",
      "pap": "framework-nexus"
    },
    "title": {
      "en": "Nexus Framework",
      "es": "Marco Nexus",
      "nl": "Nexus Framework",
      "pap": "Nexus Framework"
    },
    "category": "framework",
    "status": "coming-soon",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "shortDescription": {
      "en": "A coming-soon TGWE framework tool for structured work.",
      "es": "Una próxima herramienta de marco de TGWE para el trabajo estructurado.",
      "nl": "Een binnenkort beschikbare TGWE-raamwerktool voor gestructureerd werk.",
      "pap": "Un hèrmènt di struktura di TGWE ku ta bin pronto pa trabou strukturá."
    },
    "description": {
      "en": "This item is not available to open yet. It is shown here as coming soon.",
      "es": "Este elemento aún no se puede abrir. Se muestra aquí como próximamente.",
      "nl": "Dit item kan nog niet worden geopend. Het wordt hier getoond als binnenkort beschikbaar.",
      "pap": "E artíkulo aki no por wòrdu habrí ainda. E ta wòrdu mustrá akinan komo pronto disponibel."
    },
    "useContext": {
      "en": "Organizes practice and content relationships without replacing direct perception, disciplined action, or canonical sequencing.",
      "es": "Organiza la práctica y las relaciones entre contenidos sin reemplazar la percepción directa, la acción disciplinada ni el orden canónico.",
      "nl": "Ordent de oefening en de samenhang tussen inhoud zonder directe waarneming, gedisciplineerd handelen of de canonieke volgorde te vervangen.",
      "pap": "Ta organisá práktika i e relashonnan di kontenido sin remplasá persepshon direkto, akshon disipliná, ni e òrden kanóniko."
    },
    "image": null,
    "imageAlt": null,
    "version": null,
    "releaseDate": null,
    "license": null,
    "builds": [],
    "faq": null,
    "relatedMediaSeasons": [],
    "relatedCourses": []
  },
  {
    "id": "nenadi",
    "slug": {
      "en": "nenadi",
      "es": "nenadi",
      "nl": "nenadi",
      "pap": "nenadi"
    },
    "title": {
      "en": "NeNadi",
      "es": "NeNadi",
      "nl": "NeNadi",
      "pap": "NeNadi"
    },
    "category": "tool",
    "status": "coming-soon",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "shortDescription": {
      "en": "A coming-soon content-streaming tool.",
      "es": "Una próxima herramienta de transmisión de contenido.",
      "nl": "Een binnenkort beschikbare tool voor het streamen van content.",
      "pap": "Un hèrmènt di streaming di kontenido ku ta bin pronto."
    },
    "description": {
      "en": "This item is not available to open yet. It is shown here as coming soon.",
      "es": "Este elemento aún no se puede abrir. Se muestra aquí como próximamente.",
      "nl": "Dit item kan nog niet worden geopend. Het wordt hier getoond als binnenkort beschikbaar.",
      "pap": "E artíkulo aki no por wòrdu habrí ainda. E ta wòrdu mustrá akinan komo pronto disponibel."
    },
    "useContext": {
      "en": "Serves access to material while remaining subordinate to the Work itself.",
      "es": "Brinda acceso al material sin dejar de estar subordinado a la Obra misma.",
      "nl": "Biedt toegang tot het materiaal en blijft daarbij ondergeschikt aan het Werk zelf.",
      "pap": "Ta duna akseso na e material miéntras ta keda subordiná na e Obra mes."
    },
    "image": null,
    "imageAlt": null,
    "version": null,
    "releaseDate": null,
    "license": null,
    "builds": [],
    "faq": null,
    "relatedMediaSeasons": [],
    "relatedCourses": []
  }
];
